var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.24,
    height: 23.12,
    viewBox: "0 0 22.24 23.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NOTIFICATIONS",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2785",
    "data-name": "Groupe 2785",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1966",
    "data-name": "Trac\\xE9 1966",
    d: "M21.56,16.43s-.06-.05-.09-.07a7.385,7.385,0,0,1-2.54-5.58V7.71A7.72,7.72,0,0,0,11.22,0h-.2A7.723,7.723,0,0,0,3.3,7.71v3.07A7.369,7.369,0,0,1,.76,16.36a.549.549,0,0,0-.09.07,1.929,1.929,0,0,0,1.26,3.39H6.97a4.132,4.132,0,0,0,4.05,3.3h.2a4.14,4.14,0,0,0,4.05-3.3h5.04a1.929,1.929,0,0,0,1.26-3.39ZM4.96,10.78V7.71A6.063,6.063,0,0,1,10.8,1.66a.335.335,0,0,0,.1,0h.52a6.063,6.063,0,0,1,5.84,6.05v3.07a9.06,9.06,0,0,0,3.2,6.91c.02.01.03.03.05.04a.272.272,0,0,1,.06.17.284.284,0,0,1-.27.28H1.92a.286.286,0,0,1-.28-.28.272.272,0,0,1,.06-.17.176.176,0,0,0,.05-.04,9.06,9.06,0,0,0,3.2-6.91ZM8.9,19.82h4.45a2.469,2.469,0,0,1-2.23,1.64,2.472,2.472,0,0,1-2.21-1.64Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/notificationsIcon.c868dd520e4b33b04470cb3ed39904f5.svg";
export { ForwardRef as ReactComponent };